export const FORM_SELECT_TYPES = {
  BREED: 'BREED',
  REPETITION: 'REPETITION'
} as const;

export const FORM_SELECT_COMPONENT_TYPES = {
  BREED: {
    title: `formSelectTypes.breed.title`,
    registerAs: 'breed'
  },
  REPETITION: {
    title: 'formSelectTypes.repetition.title',
    registerAs: 'repetition'
  }
} as const;
